export default __webpack_public_path__ + "static/media/bg-banner-5.190f094f.jpg";